import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../Context";
export const pageUrl = () => "/react-js/introduction";

export default function ReactIntro() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("React Js Introduction | Aspirant's Home");

        const urls = {
            'next': '/react-js/features'
        }

        path.setPreviousNext(urls);
    },[])



    return (
        <>
            <section className='mt-5 mb-5'>
                <h3>React Js Introduction</h3>
                <div className='mt-4'>
                    <p>ReactJS is a free and open-source front-end JavaScript library used to develop interactive user interfaces. It is known for its simplicity, rich features, and component-based architecture.</p>
                    <p>ReactJS enables the creation of impressive user interfaces (UIs). It is search engine friendly. React Application guarantees faster rendering. React.js creates a custom virtual DOM, which is faster than the conventional DOM, leading to improved app performance. </p>
                    <br />
                    <p>Basically, React is <strong>Extremely Popular</strong>, <strong>Declarative</strong>, <strong>Component-based</strong>, <strong>State-driven</strong> javascript library for building user interfaces, created by <strong>Facebook</strong>.</p>
                    <p>Ok, lets explain each point briefly -</p>
                </div>
                <div className='mt-4 mb-5'>
                    <h5>What is Component&nbsp;?</h5>
                    <div className='mt-4'>
                        <ul style={{ listStyle: 'disc' }}>
                            <li>Components are the building blocks of user interfaces in React.</li>
                            <li>We build complex UIs by building and combining multiple components.</li>
                        </ul>
                        <p>Look at the below complex ui</p>
                        <div className='row'>
                            <div className='col-sm-5'>
                                <div className='mt-3'>
                                    <img className='img-fluid' src='../assets/react/component-parts.png' />
                                </div>
                            </div>
                            <div className='col-sm-7'>
                                <p>In this complex UI, we can divide each part into components. In this picture, each color box indicates a new component. We can create each box as a separate component and combine them to make the full UI interfaces.</p>
                                <p>For this reason, it is easy to reuse the same component in many places and many times.</p>
                                <p>For example, in the blue box area listings data are the same UI, we have to write 4 times the same UI. But if you make a component for this, you can call the component 4 times. </p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='mt-4 mb-5'>
                    <h5>Why React is called Declarative&nbsp;?</h5>
                    <div className='mt-4'>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <ul style={{ listStyle: 'disc' }}>
                                    <li>It is declarative because, in React we have to describe how a component looks like and how they are working fully depending on data/state. The declarative syntax is called JSX.</li>
                                    <li>JSX is a syntax that combines HTML, CSS, and JavaScript as well as referencing other components.</li>
                                </ul>
                            </div>
                            <div className='col-sm-6'>
                                <div className='mt-3'>
                                    <img className='img-fluid' src='../assets/react/declarative-parts.png' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='mt-4 mb-5'>
                <h5>What is meant by State-Driven&nbsp;?</h5>
                <div className='mt-4'>
                    <div className='row mb-4'>
                        <div className='col-sm-6'>
                            <div className='mt-3'>
                                <img className='img-fluid' src='../assets/react/state-driven.png' />
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <ul style={{ listStyle: 'disc' }}>
                                <li>React is an abstraction, it is away from DOM. It never touches the DOM. Then how data is updated in React Application? That's why the State concept is coming. To sync UI with data, in React we have to call the data from State.</li>
                            </ul>
                        </div>
                    </div>
                    <p>Suppose we have an array of data that we set into a State, and this data is rendered to the UI. If we want updated data from an API, we need to trigger an event. When we receive the data from the API, we have to manually update the application state. Whenever the state is updated, the UI is re-rendered with the new data.</p>
                </div>
            </div>
            <div className='mt-4 mb-5'>
                <h5>Is React a library or a framework&nbsp;?</h5>
                <div className='mt-4'>
                    <p>React is a library for building user interfaces. It is often referred to as a "library" rather than a "framework" because it focuses on a specific part of the application (the view layer) and does not impose a strict structure or set of rules for the overall application architecture. Unlike frameworks such as Angular or Ember, React is more lightweight and flexible, allowing developers to use it alongside other libraries and tools to build applications according to their specific needs.</p>
                </div>
            </div>
            <section className='mb-5'>
                <h3>Server Requirement</h3>
                <p>To set up a development environment for a React.js project, you'll need to install Node.js and npm (Node Package Manager) first, as React.js applications are typically built using npm.</p>
                <p><a href="/node-js/environment-setup">Here</a>, is the step by step guide of how to install Node.js.</p>
            </section>
        </>
    )
}
